
export default function studio_text() {

    var cur_id = 0;
    const elm = document.querySelector('#text')

    if(elm){

        if(!window.typeout){
        
            var variables = document.querySelectorAll('#prompts');
            
            for (var i = 0; i < variables.length; i++) {
                var newScript = document.createElement('script');
                newScript.type = 'text/javascript';
                newScript.text = variables[i].text;
                document.body.appendChild(newScript);
            }

            if(window.typeout){
                setTimeout(function(){
                    start_text();
                }, 1000);
            }

        }else{
            setTimeout(function(){
                start_text();
            }, 1000);
        }

    }

    function start_text(){

        if(cur_id >= window.typeout.length){
            cur_id = 0;
        }

        const text = window.typeout[cur_id];
        elm.innerHTML = '';

        elm.style.opacity = 1;

        typeOut(elm, text, 20, 0);

        cur_id++;

    };


    function getRandomNumber(min, max, ignore) {
        if (min >= max) {
          throw new Error("Min should be less than Max.");
        }
      
        let randomNumber;
        do {
          randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
        } while (randomNumber === ignore);
      
        return randomNumber;
    }




    function typeOut(element, text, speed, delay) {

        let index = 0;
        
        // const words = text.split(' ');

        function type() {

            if (index < text.length-1) {
                
                element.textContent += text[index];
                index++;
        
                setTimeout(type, speed);
    
            }else{
                element.textContent = text;

                setTimeout(function(){
                    start_text();
                }, 3000);
            }
        
        }

        type();
    
        // setTimeout(function(){
        //     type();
        // }, delay);
    }

};
